import { InferType, number, object, string } from 'yup';

export const PcpPersonalGoalSchema = object().shape({
  id: number().required(),
  name: string().required(),
});

export type PcpPersonalGoal = InferType<typeof PcpPersonalGoalSchema>;
